var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"table-base"},[_c('div',{staticClass:"table-base__table-container"},[_vm._t("default"),_vm._t("settings")],2),_vm._t("footer")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }